"use strict";

exports.__esModule = true;
exports.MapElement = MapElement;
var _react = _interopRequireWildcard(require("react"));
var _api = require("@react-google-maps/api");
var _Core = require("../../Core");
var _DeviceDataItemSubscription = require("../../Device/DeviceDataItemSubscription");
var _constants = require("../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* eslint-disable */

var GOOGLE_MAP_STYLES = [{
  elementType: "geometry",
  stylers: [{
    color: "#ebe3cd"
  }]
}, {
  elementType: "labels.text.fill",
  stylers: [{
    color: "#523735"
  }]
}, {
  elementType: "labels.text.stroke",
  stylers: [{
    color: "#f5f1e6"
  }]
}, {
  featureType: "administrative",
  elementType: "geometry",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#c9b2a6"
  }]
}, {
  featureType: "administrative.land_parcel",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative.land_parcel",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#dcd2be"
  }]
}, {
  featureType: "administrative.land_parcel",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative.neighborhood",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative.neighborhood",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "landscape.natural",
  elementType: "geometry",
  stylers: [{
    color: "#dfd2ae"
  }]
}, {
  featureType: "poi",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi",
  elementType: "geometry",
  stylers: [{
    color: "#dfd2ae"
  }]
}, {
  featureType: "poi",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#93817c"
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry.fill",
  stylers: [{
    color: "#a5b076"
  }]
}, {
  featureType: "road",
  elementType: "geometry",
  stylers: [{
    color: "#f5f1e6"
  }]
}, {
  featureType: "road",
  elementType: "labels",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "road",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "road.arterial",
  elementType: "geometry",
  stylers: [{
    color: "#fdfcf8"
  }]
}, {
  featureType: "road.arterial",
  elementType: "labels",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry",
  stylers: [{
    color: "#f8c967"
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#e9c031"
  }]
}, {
  featureType: "road.highway",
  elementType: "labels",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "road.highway.controlled_access",
  elementType: "geometry",
  stylers: [{
    color: "#e98d58"
  }]
}, {
  featureType: "road.highway.controlled_access",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#db8555"
  }]
}, {
  featureType: "road.local",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "road.local",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#806b63"
  }]
}, {
  featureType: "transit",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "transit.line",
  elementType: "geometry",
  stylers: [{
    color: "#dfd2ae"
  }]
}, {
  featureType: "transit.line",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#8f7d77"
  }]
}, {
  featureType: "transit.line",
  elementType: "labels.text.stroke",
  stylers: [{
    color: "#ebe3cd"
  }]
}, {
  featureType: "transit.station",
  elementType: "geometry",
  stylers: [{
    color: "#dfd2ae"
  }]
}, {
  featureType: "transit.station",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "water",
  elementType: "geometry.fill",
  stylers: [{
    color: "#a8d7ff"
  }]
}, {
  featureType: "water",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "water",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#92998d"
  }]
}];
var LAT_DATA_ITEM = {
  name: "latitude",
  type: "LOCATION",
  category: _constants.CATEGORY_EVENT
};
var LNG_DATA_ITEM = {
  name: "longitude",
  type: "LOCATION",
  category: _constants.CATEGORY_EVENT
};

/**
 * Displays a particular property of a device, e.g. name or uuid.
 */
function MapElement(props) {
  var height = props.height,
    width = props.width,
    deviceList = props.deviceList;
  var _React$useContext = _react["default"].useContext(_Core.SelectionContext),
    selected = _React$useContext.selected,
    setSelection = _React$useContext.setSelection;
  var _useState = (0, _react.useState)(undefined),
    showDescriptionForDevice = _useState[0],
    setShowDescriptionForDevice = _useState[1];
  var _useState2 = (0, _react.useState)({
      lat: 20.5937,
      lng: 78.9629
    }),
    center = _useState2[0],
    setCenter = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    mapInstance = _useState3[0],
    setMapInstance = _useState3[1];
  var _useState4 = (0, _react.useState)({}),
    deviceLocationMap = _useState4[0],
    setDeviceLocationMap = _useState4[1];

  // Generate options from props
  var options = {
    mapTypeControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: GOOGLE_MAP_STYLES
  };
  function updateDeviceLatitude(deviceUUID) {
    return function updateLatitude(packet) {
      if (packet) {
        setDeviceLocationMap(function (prevDeviceLocationMap) {
          var _Object$assign;
          return Object.assign({}, prevDeviceLocationMap, (_Object$assign = {}, _Object$assign[deviceUUID] = Object.assign({
            lng: 0
          }, prevDeviceLocationMap[deviceUUID], {
            lat: parseFloat(packet.value)
          }), _Object$assign));
        });
      }
    };
  }
  function updateDeviceLongitude(deviceUUID) {
    return function updateLongitude(packet) {
      if (packet) {
        setDeviceLocationMap(function (prevDeviceLocationMap) {
          var _Object$assign2;
          return Object.assign({}, prevDeviceLocationMap, (_Object$assign2 = {}, _Object$assign2[deviceUUID] = Object.assign({
            lat: 0
          }, prevDeviceLocationMap[deviceUUID], {
            lng: parseFloat(packet.value)
          }), _Object$assign2));
        });
      }
    };
  }
  var onLoad = _react["default"].useCallback(function onLoad(loadedMapInstance) {
    setMapInstance(loadedMapInstance);
    // $FlowFixMe
    var styledMapType = new google.maps.StyledMapType(GOOGLE_MAP_STYLES, {
      name: "VimanaMap"
    });
    loadedMapInstance.mapTypes.set("styled_map", styledMapType);
    loadedMapInstance.setMapTypeId("styled_map");
  });
  var onIdle = _react["default"].useCallback(function onIdle() {
    if (mapInstance) {
      setCenter(mapInstance.getCenter());
      var bounds = mapInstance.getBounds();
      var visibleDeviceList = deviceList.filter(function (device) {
        var deviceLocation = deviceLocationMap[device.uuid];
        if (deviceLocation && deviceLocation.lat && deviceLocation.lng) {
          return bounds.contains(deviceLocation);
        }
        return false;
      }).map(function (device) {
        return device.uuid;
      });
      if (selected && selected.deviceList) {
        var selectedDevices = selected.deviceList;
        if (selectedDevices.length === visibleDeviceList.length) {
          if (isDeviceListSame(selectedDevices, visibleDeviceList)) {
            return;
          }
        }
      }
      setSelection({
        deviceList: visibleDeviceList
      });
    }
  });
  var renderMap = function renderMap() {
    return /*#__PURE__*/_react["default"].createElement(_api.GoogleMap, {
      id: "maps",
      zoom: 5,
      options: options,
      onLoad: onLoad,
      onIdle: onIdle,
      mapContainerStyle: {
        height: height,
        width: width
      },
      center: center
    }, /*#__PURE__*/_react["default"].createElement(_api.MarkerClusterer, {
      averageCenter: true
    }, function (clusterer) {
      return deviceList.map(function (device) {
        return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSubscription.DeviceDataItemSubscription, {
          deviceUuid: device.uuid,
          dataItem: LAT_DATA_ITEM,
          onData: updateDeviceLatitude(device.uuid)
        }, function () {
          return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSubscription.DeviceDataItemSubscription, {
            deviceUuid: device.uuid,
            dataItem: LNG_DATA_ITEM,
            onData: updateDeviceLongitude(device.uuid)
          }, function () {
            return /*#__PURE__*/_react["default"].createElement(_api.Marker, {
              key: "marker-" + device.uuid,
              position: {
                lat: deviceLocationMap[device.uuid] ? deviceLocationMap[device.uuid].lat : 0,
                lng: deviceLocationMap[device.uuid] ? deviceLocationMap[device.uuid].lng : 0
              },
              clusterer: clusterer,
              clickable: true,
              title: device.uuid,
              onClick: function onClick() {
                // $FlowFixMe
                setShowDescriptionForDevice(Object.assign({}, device));
              }
            });
          });
        });
      });
    }), showDescriptionForDevice ? /*#__PURE__*/_react["default"].createElement(_api.InfoWindow, {
      key: "info-window-" + showDescriptionForDevice.uuid,
      position: deviceLocationMap[showDescriptionForDevice.uuid],
      onCloseClick: function onCloseClick() {
        setShowDescriptionForDevice(undefined);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null, showDescriptionForDevice.name)) : null);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: width,
      height: height
    }
  }, renderMap());
}
function isDeviceListSame(array1, array2) {
  return array1.reduce(function (acc, device1) {
    if (!acc) {
      return false;
    }
    return !!array2.includes(device1);
  }, true);
}